import { render } from "./PointTransactionHistory.vue?vue&type=template&id=06d09f7e&scoped=true&ts=true"
import script from "./PointTransactionHistory.vue?vue&type=script&lang=ts"
export * from "./PointTransactionHistory.vue?vue&type=script&lang=ts"

import "./PointTransactionHistory.vue?vue&type=style&index=0&id=06d09f7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d09f7e"]])

export default __exports__